import { render } from "./ads.vue?vue&type=template&id=63724a82&ts=true"
import script from "./ads.vue?vue&type=script&lang=ts"
export * from "./ads.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nhonnguyen/Documents/exoty/frontend/exoty-backoffice-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__